import { render, staticRenderFns } from "./view-product-pricing.vue?vue&type=template&id=20c5ed0e&"
import script from "./view-product-pricing.vue?vue&type=script&lang=ts&"
export * from "./view-product-pricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports